import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Input } from 'antd';

import requestAPI from '../../../helpers/requestAPI';
import { setChangedBrowserDataWhenRename } from '../../../actions';
import { toastSuccess, toastError } from '../../../utils/toastr';

const RenameModal = ({
	visible,
	changeVisible,
	directory,
	site_id,
	setChangedBrowserDataWhenRename,
	selectedElements,
	browserData
}) => {
	const [ fileName, setFileName ] = useState('');

	const sendData = () => {
		const params = {
			routeParams: {
				route: 'rename'
			},
			method: 'PUT',
			data: {
				site_id,
				directory,
				name: selectedElements[0].name,
				new_name: fileName
			}
		};

		const newBrowserData = [];
		const newElementNameIndex = browserData.findIndex((el) => el.label === selectedElements[0].name);

		browserData.forEach((element, i) => {
			if (newElementNameIndex === i) {
				const data = JSON.parse(element.value);
				const renamedElement = {
					value: JSON.stringify({
						name: fileName,
						siteName: data.siteName,
						siteId: data.siteId,
						isFolder: data.isFolder,
						directory: data.directory
					}),
					label: fileName,
					showCheckbox: false
				};

				newBrowserData.push(renamedElement);
			} else {
				newBrowserData.push(element);
			}
		});

		requestAPI(params)
			.then((response) => {
				if (response.data.ms === 'Ошибка' || response.status !== 200) {
					toastError(response.data.error);
				} else {
					setChangedBrowserDataWhenRename(newBrowserData);
					toastSuccess('File was renamed.', 'OK');
				}
			})
			.catch((err) => {
				toastError(err);
			});
	};

	const handleSubmit = () => {
		changeVisible();
		sendData();
	};

	return (
		<Modal title="Rename:" visible={visible} onCancel={changeVisible} onOk={handleSubmit}>
			<Input placeholder="Enter new name" value={fileName} onChange={(e) => setFileName(e.target.value)} />
		</Modal>
	);
};

const mapStateToProps = (state) => {
	return {
		site_id: state.selectedElement.siteId,
		directory: state.selectedElement.directory,
		selectedElements: state.selectedElement.selectedElements,
		browserData: state.files.browserData
	};
};

const mapDispatchToProps = (dispatch) => ({
	setChangedBrowserDataWhenRename: (data) => dispatch(setChangedBrowserDataWhenRename(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(RenameModal);
